import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable()
export class IsssteService {
  constructor(private http: HttpClientService) {}

  public request_info(person_id: number): Observable<any> {
    const options = {
      person_id: person_id,
    };
    return this.http.post("/api/issste", options).pipe(tap((_) => console.log("IsssteService.request_info: Ok.")));
  }
}
